"use client";

// app/blog/_components/BookmarkButton.tsx
// B2B affordance. Currently localStorage-only — wire to your user-saved-articles
// API in `toggle()`.

import { useEffect, useState } from "react";
import { BookmarkIcon } from "./icons";

const STORAGE_KEY = "lx-bookmarks";

function readSet(): Set<string> {
  if (typeof window === "undefined") return new Set();
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return new Set<string>(raw ? JSON.parse(raw) : []);
  } catch {
    return new Set();
  }
}

function writeSet(set: Set<string>) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...set]));
  } catch {}
}

export function BookmarkButton({ slug }: { slug: string }) {
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    setSaved(readSet().has(slug));
  }, [slug]);

  const toggle = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    const set = readSet();
    if (set.has(slug)) set.delete(slug);
    else set.add(slug);
    writeSet(set);
    setSaved(set.has(slug));
    // YOUR API HOOK:
    // fetch("/api/user/saved-articles", { method: set.has(slug) ? "POST" : "DELETE", body: JSON.stringify({ slug }) });
  };

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={saved ? "Remove from saved" : "Save article"}
      aria-pressed={saved}
      className={`lx-bookmark${saved ? " saved" : ""}`}
    >
      <BookmarkIcon size={18} filled={saved} />
    </button>
  );
}
